(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/play-page-container.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/play-page-container.js');

'use strict';

const {
  useEffect,
  useMemo
} = React;
const {
  useAtomValue
} = jotai;
const {
  pinLocationAtom,
  shouldShowPinAtom,
  locationConfirmedAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  charityAtom
} = svs.lyckoplatsen.shared_charity.jotai.atoms;
const {
  isMovingAtom,
  isUserIdleAtom,
  mapZoomLevelAtom
} = svs.lyckoplatsen.shared_map.atoms;
const {
  CONSTANTS
} = svs.lyckoplatsen.components.shared_constants;
const PlayPageContainer = _ref => {
  let {
    children
  } = _ref;
  const locationConfirmed = useAtomValue(locationConfirmedAtom);
  const pinLocation = useAtomValue(pinLocationAtom);
  const shouldShowPin = useAtomValue(shouldShowPinAtom);
  const isUserIdle = useAtomValue(isUserIdleAtom);
  const zoomLevel = useAtomValue(mapZoomLevelAtom);
  const isMoving = useAtomValue(isMovingAtom);
  const charity = useAtomValue(charityAtom);
  const isNativeApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp', window) && svs.core.config.data.svsconfig.isNativeApp;
  const hasMobileKeyboard = svs.lyckoplatsen.hooks.useMobileKeyboardDetect();
  const isIphoneSafari = svs.core.detect.os.iOS() && svs.core.detect.formfactor.mobile() && navigator.userAgent.toLowerCase().indexOf('safari') > -1;
  const classNames = useMemo(() => {
    const arr = ['lp-page-play', 'lp-page-grow'];
    if (zoomLevel >= CONSTANTS.PLACE_PIN_ZOOM_LEVEL) {
      arr.push('place-pin-zoom-level');
    }
    if (shouldShowPin) {
      arr.push('showing-pin');
    }
    if (locationConfirmed) {
      arr.push('has-confirmed-location');
    }
    if (pinLocation.lat) {
      arr.push('has-pin-location');
    }
    if (isMoving) {
      arr.push('map-is-moving');
    }
    if (isUserIdle) {
      arr.push('lp-user-is-idle');
    }
    if (charity) {
      arr.push('charity-selected');
    }
    if (isNativeApp) {
      arr.push('is-native-app');
    }
    if (hasMobileKeyboard) {
      arr.push('has-mobile-keyboard');
    }
    return arr;
  }, [zoomLevel, shouldShowPin, locationConfirmed, pinLocation.lat, isMoving, isUserIdle, charity, isNativeApp, hasMobileKeyboard]);
  useEffect(() => {
    const body = document.body;
    if (isIphoneSafari) {
      classNames.forEach(cls => body.classList.add(cls));
    }
    return () => {
      if (isIphoneSafari) {
        classNames.forEach(cls => body.classList.remove(cls));
      }
    };
  }, [classNames, isIphoneSafari]);
  useEffect(() => {
    svs.lyckoplatsen.utils.ui.hideFooter();
    return svs.lyckoplatsen.utils.ui.showFooter;
  }, []);
  return React.createElement("div", {
    className: classNames.join(' ')
  }, children);
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  PlayPageContainer
});

 })(window);